import { colors } from 'styles'

export default {
  main: {
    color: 'black',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    fontFamily: 'Open Sans Condensed',
  },
  container: {
    display: 'flex',
    boxShadow: '8px 8px 12px #aaa',
    height: '500px',
  },
  logoContainer: {
    width: '450px',
    backgroundColor: colors.darkBlue,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  },
  infoContainer: {
    width: '450px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    color: colors.grey,
  },
  text: {
    padding: '30px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  sloganSparklane: {
    fontSize: '24px',
  },

}
